// src/pages/ProfessionalTrainingsPage.jsx
import React from "react";
import PageShell from "../components/layout/PageShell";
import TrainingGrid from "../features/training/TrainingGrid";
import ContactSection from "../components/shared/ContactSection";

export default function ProfessionalTrainingsPage() {
  return (
    <PageShell>
      <TrainingGrid category="Professional Training" heading="Professional training programs" />
      <ContactSection />
    </PageShell>
  );
}